//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext } from "react";

// custom pages
import Context from 'context/context';
import CollapseComponent from "./CollapseComponent";
import NoData from "./NoData";
import { useRowStyles } from "./style";

// material-ui
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useTranslation } from 'react-i18next';
// material-ui icons
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import Pagination from '@material-ui/lab/Pagination';

//Helpers
import {pointsFormat, currencyFormat, dateFormat} from "helpers/dataFormat"

function Row(props) {
  const { state } = useContext(Context);
  const { object, subHeadings, collapsible, keys, subKeys, handleSort, sort, language } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();
  const { t } = useTranslation();

  useEffect(() => {
    if (sort) handleSort({ asc: true })
    if (!sort) handleSort({ des: true })
  }, [keys])

  // point formatting func
  // const pointFormat = (point, Fieldname) => {
  //     var nfObject = "";
  //     if (Fieldname == "credits_applied") {
  //       nfObject = new Intl.NumberFormat("en-US", {
  //         style: "currency",
  //         currency: "USD",
  //       });
  //     } else {
  //       nfObject = new Intl.NumberFormat("en-US");
  //     }

  //     var res = nfObject.format(point);
  //     return res;
  // };

  const commaFormat = (val) => {
    return val?.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  return (
    <React.Fragment>
      {open == true ? (
        <TableRow className={classes.tableRow}>
          {keys.map((k, i) => (
            <TableCell
              key={i}
              className={classes.cells}
            >
              {k == "points" || k === "points_redeemed" || k == "credits_applied"
                ? pointsFormat(object[k], language)
                : k == 'extended_sales_amount' || k == 'credit_issued' || k == 'purchase_value' ? currencyFormat(object[k], language, state?.userInfo?.loyalty_organization_name) : k == 'order_date'||k == 'post_date' || k == 'reedemption_date' ? dateFormat(object[k], language) :
                  k == 'loyalty_organization_name' ? t(object[k]) : t(object[k])}
            </TableCell>
          ))}

          {collapsible && (
            <TableCell className={classes.data}>
              <div
                aria-label="expand row"
                size="small"
                className="viewHideDetails-btn"
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <div className="view-hide-table-button">
                    <span className={classes.collapseText}>{t("Hide Details")}</span>
                  </div>
                ) : (
                  <div className="view-hide-table-button">
                    <span className={classes.collapseText}>{t("Show Details")}</span>
                  </div>
                )}
              </div>
            </TableCell>
          )}
        </TableRow>
      ) : (
        <TableRow>
          {keys.map((k, i) => (
            <TableCell
              key={i}
              className={classes.data}
            >
              {k == "points" || k === "points_redeemed" || k == "credits_applied"
                ? pointsFormat(object[k], language)
                : k == 'extended_sales_amount' || k == 'credit_issued' || k == 'purchase_value' ? (state?.userInfo?.loyalty_organization_name== "Henry Schein Dental" ||k == 'purchase_value'||k == 'extended_sales_amount')?currencyFormat(object[k], language, state?.userInfo?.loyalty_organization_name):(k == 'credit_issued'&&new Date(object['reedemption_date'])< new Date("2023-10-31"))?"PRIV":currencyFormat(object[k], language, state?.userInfo?.loyalty_organization_name) : k == 'order_date' || k == 'post_date'|| k == 'reedemption_date' ? dateFormat(object[k], language) :
                    k == 'loyalty_organization_name' ? t(object[k]) : t(object[k])}
            </TableCell>
          ))}

          {collapsible && (
            <TableCell className={classes.data}>
              <div
                aria-label="expand row"
                size="small"
                className={`${classes.IconButton} viewHideDetails-btn`}
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <div className="view-hide-table-button">
                    <span className={classes.collapseText}>{t("Hide detail")}</span>
                  </div>
                ) : (
                  <div className="view-hide-table-button">
                    <span className={classes.collapseText}>{t("View detail")}</span>
                  </div>
                )}
              </div>
            </TableCell>
          )}
        </TableRow>
      )}

      {/* collapsible view */}
      {collapsible && (
        <CollapseComponent
          open={open}
          headings={subHeadings}
          data={object.data}
          keys={subKeys}
          language={language}
        />
      )}
    </React.Fragment>
  );
}

export default function CollapsibleTable(props) {
  let {
    headings,
    subHeadings,
    data,
    collapsible,
    keys,
    subKeys,
    sorting,
    sortingFields,
    currentTab,
    language,
    disablePagination,
    count,
    offset,
    handlePagination,
  } = props;

  const classes = useRowStyles();
  const [sort, setSort] = useState(false);

  let rowData = [];
  rowData =  data?.sort(function (a, b) {
    return new Date(b[sortingFields.row]) - new Date(a[sortingFields.row]);
  });


  // sorting func
  const handleSort = (values) => {
    let row = sortingFields.row;
    if(sorting){

    if (values.asc) {
      data.sort(function (a, b) {
        return new Date(a[row]) - new Date(b[row]);
      });
    }
    if (values.des) {
      data.sort(function (a, b) {
        return new Date(b[row]) - new Date(a[row]);
      });
    }
  }

  };

  return data && data.length > 0 ? (
    <div className={classes.root}>
    <TableContainer>
      <Table aria-label="collapsible table">
        <TableHead className={classes.tableHeader}>
          <TableRow>
            {sorting
              ? headings.map((h, i) => (
                <TableCell key={i} className={classes.heading}>
                  {sortingFields.column == h ? (
                    <React.Fragment>
                      {h}&nbsp;
                      {sort ? (
                        <ArrowDownwardIcon
                          className={classes.sortIcon}
                          onClick={() => {
                            setSort(false);
                            handleSort({ des: true });
                          }}
                        />
                      ) : (
                        <ArrowUpwardIcon
                          className={classes.sortIcon}
                          onClick={() => {
                            setSort(true);
                            handleSort({ asc: true });
                          }}
                        />
                      )}
                    </React.Fragment>
                  ) : (
                    h
                  )}
                </TableCell>
              ))
              : headings.map((h, i) => (
                <TableCell key={i} className={classes.heading}>
                  {h}
                </TableCell>
              ))}
            {/* {collapsible && <TableCell className={classes.heading} />} */}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowData &&
            rowData.length > 0 &&
            rowData.map((d, i) => (
              <Row
                key={i}
                object={d}
                subHeadings={subHeadings}
                collapsible={collapsible}
                keys={keys}
                subKeys={subKeys}
                handleSort={handleSort}
                sort={sort}
                language={language}
              />
            ))}
        </TableBody>
      </Table>
    </TableContainer>
     {!disablePagination && (
      <Pagination
        className={classes.pagination}
        variant='outlined'
        shape='rounded'
        count={count}
        page={offset}
        siblingCount={1}
        onChange={(event, value) => {
          handlePagination(value);
        }}
      />
    )}
    </div>
  ) : (
    <NoData currentTab={currentTab} />
  );
}
